<template>
  <div class="config-page-body">
    <div style="margin-top: 40px; margin-bottom: 20px">
      <div></div>
      <v-card-subtitle>Omni Status</v-card-subtitle>
      <v-divider />
      Last Status: {{ deluge.omni_client_state?.status }}
    </div>
  </div>

  <div
    class="config-page-body"
    v-if="connected">
    <div style="margin-top: 40px; margin-bottom: 20px">
      <div></div>
      <v-card-subtitle>Omni Connection</v-card-subtitle>
      <v-divider />
      <div class="connection">
        Connected to
        <strong>{{ deluge.omni_connection.ip_address }}</strong>
        as
        <strong>{{ deluge.omni_connection.username }}</strong>
      </div>

      <p>
        <v-btn
          v-if="connected"
          :disabled="!ableToSync"
          @click="startSync"
          color="primary"
          variant="flat">
          <v-icon class="ml-1 mr-2">mdi-refresh</v-icon>
          {{ syncButtonText }}
        </v-btn>
      </p>
    </div>
  </div>

  <div
    class="config-page-body"
    v-else>
    <div style="margin-top: 40px; margin-bottom: 20px">
      <div></div>
      <v-card-subtitle>Omni Connection</v-card-subtitle>
      <v-divider />
      <div class="connection">Not Connected</div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { deluge } from '@/stores/deluge.js';
import { $http } from '@/stores/http.js';

const connected = computed(() => deluge.omni_connection.connected);
const syncStatus = computed(() => deluge.omni_client_state?.status);

const syncAbleStates = ['NOT_SYNCED', 'SYNCED', 'SYNC_ERROR'];

const ableToSync = computed(() => {
  return syncAbleStates.includes(syncStatus.value);
});

const syncButtonText = computed(() => {
  if (ableToSync.value) {
    return 'Full Sync';
  }

  return 'Syncing...';
});

function startSync() {
  $http('GET', '/omni/omni_client/sync');
  console.log('startSync');
}
</script>
<style scoped>
.connection {
  margin: 10px 0 10px 0;
  padding: 10px;
  outline: 1px solid #ccc;
  border-radius: 5px;
  font-size: 1.2em;
}
</style>
